import React from "react";

const SuccessMetrics = () => {

    const metrics = [
        {
            number: "50+",
            title: "Projects Delivered",
            desc: "Successfully launched digital products across industries."
        },
        {
            number: "98%",
            title: "Client Satisfaction",
            desc: "Long-term partnerships built on trust and results."
        },
        {
            number: "10M+",
            title: "Users Reached",
            desc: "Applications impacting millions of users worldwide."
        },
        {
            number: "15+",
            title: "Industries Served",
            desc: "From startups to enterprise-level organizations."
        }
    ];

    return (
        <>
            <section className="sm-section">

                <div className="sm-bg-circle circle-1"></div>
                <div className="sm-bg-circle circle-2"></div>

                <div className="sm-container">

                    <div className="sm-heading">

                        <span>OUR IMPACT</span>

                        <h2>
                            Results That
                            <br />
                            Speak For Themselves
                        </h2>

                        <p>
                            Every project we build is focused on measurable growth,
                            user engagement and long-term business success.
                        </p>

                    </div>

                    <div className="sm-grid">

                        {metrics.map((item, index) => (

                            <div
                                className="sm-card"
                                key={index}
                            >

                                <div className="sm-number">
                                    {item.number}
                                </div>

                                <h3>
                                    {item.title}
                                </h3>

                                <p>
                                    {item.desc}
                                </p>

                                <div className="sm-line"></div>

                            </div>

                        ))}

                    </div>

                </div>

                <style>{`

                .sm-section{
                    position:relative;
                    padding:150px 24px;
                    background:#fafafa;
                    overflow:hidden;
                }

                .sm-container{
                    max-width:1300px;
                    margin:auto;
                    position:relative;
                    z-index:2;
                }

                .sm-heading{
                    text-align:center;
                    margin-bottom:90px;
                }

                .sm-heading span{
                    display:inline-block;
                    padding:12px 22px;
                    border-radius:999px;
                    background:rgba(232,33,42,.08);
                    color:#E8212A;
                    font-size:13px;
                    font-weight:700;
                    letter-spacing:1px;
                    margin-bottom:24px;
                }

                .sm-heading h2{
                    font-size:clamp(35px,7vw,58px);
                    line-height:.95;
                    color:#111;
                        text-align: center;
                    margin-bottom:20px;
                    font-family:'Syne',sans-serif;
                }

                .sm-heading p{
                    max-width:700px;
                        text-align: center;
                    margin:auto;
                    color:#666;
                    font-size:18px;
                    line-height:1.9;
                }

                .sm-grid{
                    display:grid;
                    grid-template-columns:repeat(4,1fr);
                    gap:30px;
                }

                .sm-card{
                    position:relative;
                    padding:40px 35px;
                    border-radius:30px;
                    background:#fff;
                    border:1px solid #eee;
                    overflow:hidden;
                    transition:.4s ease;

                    box-shadow:
                    0 20px 60px rgba(0,0,0,.04);
                }

                .sm-card:hover{
                    transform:translateY(-10px);
                    border-color:#E8212A;

                    box-shadow:
                    0 30px 80px rgba(232,33,42,.12);
                }

                .sm-number{
                    font-size:50px;
                    line-height:1;
                    margin-bottom:18px;

                    background:
                    linear-gradient(
                        135deg,
                        #E8212A,
                        #FF4D4D
                    );

                    -webkit-background-clip:text;
                    -webkit-text-fill-color:transparent;

                    font-family:'Syne',sans-serif;
                }

                .sm-card h3{
                    font-size:26px;
                    margin-bottom:14px;
                    color:#111;
                    line-height:1.2;
                    font-family:'Syne',sans-serif;
                }

                .sm-card p{
                    color:#666;
                    line-height:1.8;
                    font-size:15px;
                }

                .sm-line{
                    width:70px;
                    height:4px;
                    border-radius:999px;
                    margin-top:25px;

                    background:
                    linear-gradient(
                        135deg,
                        #E8212A,
                        #FF4D4D
                    );
                }

                .sm-bg-circle{
                    position:absolute;
                    border-radius:50%;
                    filter:blur(120px);
                    opacity:.12;
                }

                .circle-1{
                    width:450px;
                    height:450px;
                    background:#E8212A;
                    top:-180px;
                    left:-180px;
                }

                .circle-2{
                    width:380px;
                    height:380px;
                    background:#FF4D4D;
                    right:-150px;
                    bottom:-150px;
                }

                @media(max-width:1100px){

                    .sm-grid{
                        grid-template-columns:repeat(2,1fr);
                    }

                }

                @media(max-width:768px){

                    .sm-section{
                        padding:100px 18px;
                    }

                    .sm-grid{
                        grid-template-columns:1fr;
                    }

                    .sm-heading h2{
                        letter-spacing:-2px;
                    }

                    .sm-number{
                        font-size:56px;
                    }

                    .sm-card h3{
                        font-size:22px;
                    }

                }

            `}</style>

            </section>
        </>
    );
};

export default SuccessMetrics;